/**
 * @module To Do List
 */
import { getField, updateField } from 'vuex-map-fields';

export default {
	namespaced: true,
	state: {
		toDoList: [],
		teamListData: [],
		resourceId: 0,
		type: 0,
	},
	getters: {
		getField,
	},
	mutations: {
		updateField,
		listGet: function (state, data) {
			state.toDoList = data;
		},

		teamListSet: function (state, data) {
			state.teamListData = data;
		},

		ResourceAndTypeSet: function (state, data) {
			state.resourceId = data.resourceId;
			state.type = data.type;
		}
	},
	actions: {
		save: function (state, data) {
			axios.post('/api/v1/todo/save', {
				description: data.description,
				done: data.done,
				resourceId: data.resourceId,
				type: data.type,
				teamId: data.teamId,
				date: data.date,
				user_id: data.user_id
			})
				.then(function () {
					state.dispatch('list', data);
				})
				.catch(error => {
					if (error.response) {
						state.dispatch('user/checkErrorMessage', error.response, { root: true });
					}
				});
		},
		isItCompleted: function (state, data) {
			axios.post('/api/v1/todo/completed', {
				id: data.id,
				resourceId: data.resourceId,
				type: data.type
			})
				.then(function () {
					state.dispatch('list', data);
				})
				.catch(error => {
					if (error.response) {
						state.dispatch('user/checkErrorMessage', error.response, { root: true });
					}
				});
		},
		list: function (state, data) {
			axios.get('/api/v1/todo/' + data.resourceId + '/' + data.type)
				.then(function (response) {
					state.commit('listGet', response.data.data);
					state.commit('ResourceAndTypeSet', data);
					state.dispatch('teamList');
				})
				.catch(error => {
					if (error.response) {
						state.dispatch('user/checkErrorMessage', error.response, { root: true });
					}
				});
		},
		deleteToDo: function (state, data) {
			axios.post('/api/v1/todo/delete', {
				id: data.id,
				resourceId: state.state.resourceId,
				type: state.state.type
			})
				.then(function () {
					state.dispatch('list', { resourceId: state.state.resourceId, type: state.state.type });
				})
				.catch(error => {
					if (error.response) {
						state.dispatch('user/checkErrorMessage', error.response, { root: true });
					}
				});
		},

		teamList: function (state) {
			axios.get('/api/v1/todo/teamList/' + state.state.resourceId + '/' + state.state.type)
				.then(function (response) {
					state.commit('teamListSet', response.data);
				});
		}
	}
}